export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      villaIsmael: "Villa Ismaël",
      villaHasna: "Villa Hasna",
      services: "Services & Tarifs",
      seniors: "Sérénité",
      family: "Séjour Famille",
      events: "Événements privés",
      contact: "Contact",
      book: "Réserver",
    },
    hero: {
      welcome: "Bienvenue",
      tagline: "Deux villas d'exception au cœur de la Palmeraie",
      subtitle:
        "Villa Hasna, maison d'hôtes familiale au cœur de la Palmeraie de Marrakech. 3 suites avec salle de bain privative, piscine 25 m chauffable, jardin 1 700 m² sans vis-à-vis. Réservation à la suite ou privatisation complète (6 personnes).",
      discover: "Découvrir Villa Hasna",
      checkAvailability: "Vérifier les disponibilités",
    },
    collection: {
      overline: "La Maison",
      title: "Une maison d'hôtes d'exception, au cœur des palmiers",
      description:
        "Villa Hasna, maison d'hôtes familiale (3 suites, jusqu'à 6 personnes), se réserve à la suite ou en privatisation complète. Nichée dans 1 700 m² de jardin, avec piscine 25 m chauffable et sans vis-à-vis, à quelques minutes du centre de Marrakech.",
      exploreHasna: "Explorer Villa Hasna",
      ismaelTag: "Villa privative · Contemporain",
      hasnaTag: "Maison d'hôtes · Beldi Chic",
    },
    why: {
      overline: "Pourquoi nous choisir",
      title: "L'art de recevoir, à la marocaine",
      privacy: {
        title: "Intimité totale",
        desc: "Deux villas sans vis-à-vis, dans un écrin de verdure préservé.",
      },
      luxury: {
        title: "Luxe discret",
        desc: "Un raffinement mesuré, des matières nobles, un design pensé pour l'émotion.",
      },
      service: {
        title: "Service hôtelier",
        desc: "Femme de maison, chef privé, transferts, bien-être : votre séjour orchestré.",
      },
      location: {
        title: "Carré d'or de la Palmeraie",
        desc: "À 3 km du centre-ville, dans le quartier le plus recherché de Marrakech.",
      },
    },
    villa: {
      // Ismaël
      ismaelCapacity: "Jusqu'à 8 personnes",
      ismaelSuites: "4 suites avec salle de bain privative",
      ismaelPool: "Piscine privée 28 mètres",
      ismaelGarden: "Jardin paysager 1 700 m²",
      ismaelMode: "Villa entière — privatisation exclusive",
      // Hasna
      hasnaCapacity: "Jusqu'à 6 personnes",
      hasnaSuites: "3 suites avec salle de bain privative",
      hasnaPool: "Piscine privée 25 mètres, chauffable en hiver",
      hasnaGarden: "Jardin paysager 1 700 m²",
      hasnaMode: "Maison d'hôtes — suite ou villa entière",
      gallery: "Galerie",
      pricing: "Tarifs",
      book: "Demander à réserver",
      viewAvailability: "Voir les disponibilités",
      ismaelStyle: "Style contemporain, lignes épurées, ambiance chic et photogénique. Privatisation exclusive.",
      hasnaStyle: "Maison d'hôtes familiale, ambiance Beldi Chic authentique, chaleureuse et intemporelle. Suite ou villa entière.",
      // Titres de section
      ismaelSectionTitle: "4 suites, une piscine 28 m, un jardin d'exception.",
      hasnaSectionTitle: "3 suites, piscine 25 m chauffable, propriétaires sur place.",
      // Suites Hasna
      hasnaSuiteTwinName: "Suite Twin Palmeraie",
      hasnaSuiteTwinDesc: "Deux lits simples, salle de bain privative — accès direct au jardin et à la piscine.",
      hasnaSuiteConfortName: "Suite Confort",
      hasnaSuiteConfortDesc: "Lit king size, salle de bain privative, vue jardin.",
      hasnaSuiteMasterName: "Suite Master — Piscine & Jardin",
      hasnaSuiteMasterDesc: "Suite d'exception avec accès direct piscine 25 m et grand jardin de palmiers.",
    },
    pricing: {
      standard: "Formule Standard",
      premium: "Formule Premium",
      touristTax: "Taxe de séjour : 30 MAD / personne / nuit",
    },
    priceGrid: {
      overline: "Grille tarifaire",
      suitesTitle: "Réservation à la suite",
      suitesIntro: "Pour un couple ou un voyageur solo — accès partagé à la piscine, au jardin et aux espaces communs.",
      entireTitle: "Privatisation villa entière",
      entireIntro: "Toute la villa rien que pour vous, en exclusivité.",
      pricePerNight: "/ nuit",
      lowSeason: "Basse saison",
      highSeason: "Haute saison",
      fromLabel: "à partir de",
      touristTax: "Taxe de séjour : 30 MAD / personne / nuit",
      minStay: "Séjour minimum : 2 nuits",
      hasnaEntireLabel: "Villa Hasna entière — 3 suites, jusqu'à 6 personnes",
      ismaelEntireLabel: "Villa Ismaël entière — 4 suites, jusqu'à 8 personnes",
      bookThisSuite: "Réserver cette suite",
      bookEntire: "Privatiser la villa",
    },
    family: {
      pageTitle: "Séjour Famille — Villa Hasna",
      overline: "Dar Hasna Collection · Villa Hasna",
      title: "Séjour",
      titleItalic: "Famille",
      tagline: "Une formule pensée pour les familles qui veulent profiter ensemble, au cœur de la Palmeraie de Marrakech",
      teaserOverline: "Nouveauté 2026",
      teaserTitle: "Un séjour famille tout compris à Villa Hasna",
      teaserSubtitle: "Toute la maison rien que pour vous : 3 suites privatisées, 2 nounous, femme de maison, jusqu'à 6 personnes (2 adultes + 4 enfants).",
      teaserCta: "Découvrir les 3 formules",
      // Pitch
      pitch1: "Le temps de votre séjour, les trois suites de Villa Hasna, maison d'hôtes familiale nichée en plein cœur des palmiers, vous sont entièrement réservées.",
      pitch2: "Sans aucun vis-à-vis, entourée de 1 700 m² de jardin et d'une piscine de 30 m chauffée en hiver, c'est un véritable terrain de jeu pour petits et grands, à quelques minutes seulement du centre-ville de Marrakech.",
      pitch3: "Nos hôtes profitent d'un climat exceptionnel toute l'année et d'un service attentionné, taillé sur mesure pour les familles qui souhaitent se retrouver, se reposer et faire découvrir Marrakech à leurs enfants en toute sérénité.",
      // Toute la maison
      houseOverline: "Toute la maison rien que pour vous",
      houseTitle: "Villa privatisée, jusqu'à 6 personnes",
      houseDesc: "Le temps de votre séjour, les trois suites de la villa sont entièrement privatisées pour votre famille (jusqu'à 6 personnes — 2 adultes et 4 enfants). Nos deux nounous font partie de la maison : présentes en permanence à Villa Hasna, ce sont des personnes que les propriétaires connaissent et en qui ils ont toute confiance depuis longtemps.",
      // Bonus
      bonusOverline: "Inclus dans les trois formules",
      bonusTitle: "Le confort, en toute discrétion",
      bonusIntro: "Sur simple demande, gratuitement : matériel bébé complet, jeux d'extérieur et d'intérieur, jeux de société (enfants & adultes), enceintes de musique, livres.",
      bonus: [
        "Privatisation des 3 suites",
        "Femme de maison à disposition",
        "Ménage quotidien inclus",
        "Thé à la menthe illimité",
        "Valise enfant rangée à l'arrivée, refaite au départ",
        "Accès piscine & jardin",
      ],
      // Formulas
      formulasOverline: "Nos trois formules",
      formulasTitle: "Choisissez le rythme qui vous ressemble",
      formulasIntro: "Trois formules pour une famille jusqu'à 6 personnes, sur une semaine complète.",
      perWeek: "/ semaine",
      forFamily: "pour 2 adultes + 4 enfants",
      plusIncluded: "En plus",
      chooseFormula: "Choisir cette formule",
      terms: "Tarifs pour la privatisation entière de Villa Hasna (3 suites) pour 2 adultes + 4 enfants, valables selon disponibilité. Séjour d'une semaine — nous consulter pour des durées différentes.",
      formulas: {
        essentielle: {
          name: "Essentielle",
          extras: [
            "Petit-déjeuner pour toute la famille",
            "Navette aéroport A/R",
            "Nounou disponible une soirée",
          ],
        },
        confort: {
          name: "Confort",
          plusPrefix: "Tout l'Essentielle, plus :",
          extras: [
            "Demi-pension",
            "1 aller-retour / jour en transport",
            "Nounou en journée + une soirée",
            "1 massage offert pour les parents",
          ],
        },
        premium: {
          name: "Premium",
          plusPrefix: "Tout le Confort, plus :",
          extras: [
            "Chauffeur privé à disposition",
            "Nounou 8h/jour + deux soirées",
            "1 massage offert pour les parents",
          ],
        },
      },
      ctaOverline: "Envie d'en savoir plus ?",
      ctaTitle: "Nous personnalisons chaque séjour famille",
      ctaSubtitle: "Contactez-nous, notre équipe vous répond en 24 h et adapte la formule à vos envies.",
    },
    services: {
      overline: "Services & Tarifs",
      title: "Une expérience sur-mesure",
      pool: "Piscine",
      dining: "Restauration",
      transport: "Transport",
      wellness: "Bien-être",
      nanny: "Service nounou",
      housekeeping: "Femme de ménage",
      extras: "Personnes & visiteurs",
      menu: "Les menus Din'Art",
      menuIntro: "Une cuisine généreuse, entre Maroc et Méditerranée, orchestrée par notre chef privé.",
    },
    events: {
      overline: "Événements privés",
      title: "Un écrin pour vos plus beaux moments",
      subtitle: "Privatisation à la journée ou avec hébergement — sur devis.",
      types: [
        "Anniversaires",
        "Baptêmes et cérémonies religieuses en petit comité",
        "Mariages religieux intimes",
        "Regroupements familiaux",
        "Séminaires résidentiels",
        "Retraites privées",
      ],
      contactUs: "Demander un devis",
    },
    booking: {
      overline: "Réservation directe",
      title: "Demander à réserver",
      subtitle: "Votre demande est traitée sous 24 heures. Aucun paiement en ligne.",
      villa: "Villa",
      selectVilla: "Choisir une villa",
      checkIn: "Arrivée",
      checkOut: "Départ",
      guests: "Voyageurs",
      formula: "Formule",
      firstName: "Prénom",
      lastName: "Nom",
      email: "Email",
      phone: "Téléphone",
      message: "Un message ? (occasion, préférences...)",
      submit: "Envoyer la demande",
      submitting: "Envoi en cours...",
      pickDates: "Choisir les dates",
      success: "Demande envoyée. Nous revenons vers vous sous 24h.",
      error: "Une erreur est survenue. Contactez-nous par WhatsApp.",
      nights: "nuits",
      hasnaChoiceLabel: "Suite souhaitée (Villa Hasna)",
      hasnaChoiceHelp: "Précisez la suite ou la privatisation entière. Modifiable avec notre équipe.",
      hasnaOptions: {
        entire: "Villa entière — 3 suites, jusqu'à 6 pax",
        master: "Suite Master — Piscine 25 m & Jardin",
        confort: "Suite Confort — lit king, vue jardin",
        twin: "Suite Twin Palmeraie — 2 lits simples",
        undecided: "Je ne sais pas encore — à discuter",
      },
    },
    contact: {
      overline: "Contact",
      title: "Écrivez-nous, appelez-nous",
      subtitle: "Notre équipe vous répond en français, anglais et arabe.",
      whatsapp: "WhatsApp",
      email: "Email",
      phone: "Téléphone",
      address: "Adresse",
      addressValue: "Sidi Yahya La Palmeraie · Marrakech 40 000",
      followUs: "Suivez-nous",
    },
    footer: {
      tagline: "Villa privative & maison d'hôtes · Palmeraie · Marrakech",
      quickLinks: "Navigation",
      legal: "Légal",
      mentions: "Mentions légales",
      privacy: "Confidentialité",
      copyright: "© 2026 Dar Hasna Collection. Tous droits réservés.",
    },
    admin: {
      login: "Connexion",
      email: "Email",
      password: "Mot de passe",
      signIn: "Se connecter",
      signOut: "Déconnexion",
      dashboard: "Tableau de bord",
      bookings: "Demandes",
      calendars: "Calendriers iCal",
      stats: "Statistiques",
      total: "Total",
      pending: "En attente",
      accepted: "Acceptées",
      declined: "Refusées",
      accept: "Accepter",
      decline: "Refuser",
      archive: "Archiver",
      guest: "Client",
      dates: "Dates",
      status: "Statut",
      action: "Actions",
      icalAirbnb: "URL iCal Airbnb",
      icalBooking: "URL iCal Booking.com",
      exportUrl: "URL d'export iCal (à ajouter dans Airbnb/Booking)",
      save: "Enregistrer",
      saved: "Enregistré",
      familyLeads: "Prospects Famille",
      filterAllVillas: "Toutes les villas",
      allSuites: "Toutes les suites (Hasna)",
    },
    seniors: {
      title: "Séjours Sérénité",
      titleItalic: "pour Seniors",
      tagline: "Le paradis, en toute tranquillité, à Marrakech.",
      badges: {
        palm: "Palmeraie",
        heated: "Piscine chauffée",
        pension: "Pension & chauffeur",
        massage: "Massages",
        concierge: "Femme de maison à disposition",
      },
      pitchOverline: "Un cocon pour prendre le temps",
      pitchTitle: "Une formule pensée pour les couples qui souhaitent prendre leur temps.",
      pitch1: "Villa Hasna est une maison d'hôtes familiale nichée en plein cœur des palmiers, à quelques minutes seulement du centre-ville de Marrakech — la pleine nature, sans jamais être isolée.",
      pitch2: "Sans aucun vis-à-vis, entourée de 1 700 m² de jardin et d'une piscine chauffée en hiver, c'est un véritable havre de paix — pensé pour les seniors qui souhaitent se reposer, visiter à leur rythme et se sentir chez eux, en mieux.",
      homeOverline: "Comme à la maison, en mieux",
      homeTitle: "Chaque hôte dispose d'une suite indépendante de 50 m² — salle de bain privative, dressing et terrasse.",
      includedOverline: "Inclus dans chaque formule",
      includedTitle: "Une attention de tous les instants",
      includedIntro: "Quel que soit le séjour, tout est prévu pour vivre en toute tranquillité — du premier jour au dernier.",
      included: {
        suite: { title: "Suite indépendante 50 m²", desc: "Salle de bain privative, dressing, terrasse, accès piscine et jardin." },
        housekeeping: { title: "Ménage quotidien", desc: "Nos équipes sont présentes toute la journée pour prendre soin de vous." },
        shuttle: { title: "Navette aéroport A/R", desc: "Accueil personnalisé à l'arrivée et au départ." },
        advice: { title: "Conseils personnalisés", desc: "Activités et visites au rythme de chacun." },
        laundry: { title: "Blanchisserie", desc: "Service de blanchisserie inclus, sans supplément." },
        pool: { title: "Piscine chauffée & jardin", desc: "Piscine 28 m, 1 700 m² de jardin sans vis-à-vis." },
      },
      formulasOverline: "Nos trois formules",
      formulasTitle: "Choisissez le rythme qui vous ressemble",
      formulasIntro: "Trois formules pour un couple, de la semaine au mois, dans une suite dédiée.",
      dur: { week: "1 semaine", fortnight: "15 jours", month: "1 mois" },
      perCouple: "pour 2 personnes",
      plusIncluded: "En plus",
      chooseFormula: "Choisir cette formule",
      terms: "Tarifs exprimés pour un couple, valables selon disponibilité sur la base de 3 suites dédiées à cette offre. Séjours possibles d'une semaine à un mois.",
      moreOverline: "Envie d'en savoir plus ?",
      moreTitle: "Nous vous envoyons toutes les formules en détail",
      moreSubtitle: "Contactez-nous, notre équipe vous répond en 24 h et personnalise chaque séjour.",
    },
    lang: { fr: "FR", en: "EN", ar: "AR" },
    brochure: {
      cta: "Recevoir la brochure",
      modalOverline: "Séjour Famille · Villa Hasna",
      modalTitle: "Votre brochure personnalisée en 24 h",
      modalSubtitle: "Renseignez vos préférences, nous vous envoyons la brochure détaillée par email et notre équipe reprend contact sous 24 h.",
      firstName: "Prénom",
      lastName: "Nom",
      email: "Email",
      phone: "Téléphone",
      formulaLabel: "Formule qui vous intéresse",
      formulaAny: "Je souhaite voir toutes les formules",
      formulaEssentielle: "Essentielle · 3 626 €/semaine",
      formulaConfort: "Confort · 5 230 €/semaine",
      formulaPremium: "Premium · 5 580 €/semaine",
      stayDates: "Dates envisagées",
      stayDatesPh: "Ex : 12-19 juillet 2027",
      guests: "Composition famille",
      guestsPh: "Ex : 2 adultes + 3 enfants (5, 8, 12 ans)",
      message: "Un mot pour nous ?",
      submit: "Envoyer et recevoir la brochure",
      submitting: "Envoi en cours...",
      success: "C'est parti ! Vérifiez votre boîte email dans quelques minutes.",
      error: "Une erreur est survenue. Contactez-nous par WhatsApp.",
      privacy: "Vos données sont utilisées uniquement pour vous adresser la brochure et vous rappeler. Aucun partage tiers.",
    },
  },

  en: {
    nav: {
      home: "Home",
      villaIsmael: "Villa Ismaël",
      villaHasna: "Villa Hasna",
      services: "Services & Rates",
      seniors: "Serenity",
      family: "Family Stay",
      events: "Private Events",
      contact: "Contact",
      book: "Book",
    },
    hero: {
      welcome: "Welcome",
      tagline: "Two exceptional villas in the heart of the Palmeraie",
      subtitle:
        "Villa Hasna, a family guesthouse in the heart of Marrakech's Palmeraie. 3 ensuite suites, 25 m heatable pool, 1,700 sqm unoverlooked garden. Book per suite or fully privatize (up to 6 guests).",
      discover: "Discover Villa Hasna",
      checkAvailability: "Check availability",
    },
    collection: {
      overline: "The House",
      title: "An exceptional guesthouse in the heart of the palms",
      description:
        "Villa Hasna, a family guesthouse (3 suites, up to 6 guests), can be booked per suite or fully privatized. Nestled in 1,700 sqm of unoverlooked garden, with a 25 m heatable pool, minutes from downtown Marrakech.",
      exploreHasna: "Explore Villa Hasna",
      ismaelTag: "Private villa · Contemporary",
      hasnaTag: "Guesthouse · Beldi Chic",
    },
    why: {
      overline: "Why choose us",
      title: "The Moroccan art of hospitality",
      privacy: { title: "Total privacy", desc: "Two villas with no overlook, in a preserved green setting." },
      luxury: { title: "Discreet luxury", desc: "Measured refinement, noble materials, design that stirs emotion." },
      service: { title: "Hotel-grade service", desc: "Housekeeper, private chef, transfers, wellness — your stay orchestrated." },
      location: { title: "Palmeraie's golden square", desc: "3 km from downtown, in Marrakech's most sought-after neighborhood." },
    },
    villa: {
      ismaelCapacity: "Up to 8 guests",
      ismaelSuites: "4 ensuite suites",
      ismaelPool: "28 m private pool",
      ismaelGarden: "1,700 sqm landscaped garden",
      ismaelMode: "Entire villa — exclusive privatization",
      hasnaCapacity: "Up to 6 guests",
      hasnaSuites: "3 ensuite suites",
      hasnaPool: "25 m private pool, heatable in winter",
      hasnaGarden: "1,700 sqm landscaped garden",
      hasnaMode: "Guesthouse — per suite or entire villa",
      gallery: "Gallery",
      pricing: "Rates",
      book: "Request to book",
      viewAvailability: "See availability",
      ismaelStyle: "Contemporary style, clean lines, chic and photogenic ambiance. Exclusive privatization.",
      hasnaStyle: "Family guesthouse, authentic Beldi Chic ambiance, warm and timeless. Per suite or entire villa.",
      ismaelSectionTitle: "4 suites, a 28 m pool, an exceptional garden.",
      hasnaSectionTitle: "3 suites, a 25 m heatable pool, hosts on site.",
      hasnaSuiteTwinName: "Twin Palmeraie Suite",
      hasnaSuiteTwinDesc: "Two single beds, private bathroom — direct access to garden and pool.",
      hasnaSuiteConfortName: "Confort Suite",
      hasnaSuiteConfortDesc: "King bed, private bathroom, garden view.",
      hasnaSuiteMasterName: "Master Suite — Pool & Garden",
      hasnaSuiteMasterDesc: "Exceptional suite with direct access to the 25 m pool and the palm garden.",
    },
    pricing: {
      standard: "Standard formula",
      premium: "Premium formula",
      touristTax: "Tourist tax: 30 MAD / person / night",
    },
    priceGrid: {
      overline: "Rate card",
      suitesTitle: "Book by suite",
      suitesIntro: "For a couple or a solo traveler — shared access to pool, garden and common areas.",
      entireTitle: "Full villa privatization",
      entireIntro: "The entire villa exclusively yours.",
      pricePerNight: "/ night",
      lowSeason: "Low season",
      highSeason: "High season",
      fromLabel: "from",
      touristTax: "Tourist tax: 30 MAD / person / night",
      minStay: "Minimum stay: 2 nights",
      hasnaEntireLabel: "Villa Hasna — 3 suites, up to 6 guests",
      ismaelEntireLabel: "Villa Ismaël — 4 suites, up to 8 guests",
      bookThisSuite: "Book this suite",
      bookEntire: "Privatize the villa",
    },
    family: {
      pageTitle: "Family Stay — Villa Hasna",
      overline: "Dar Hasna Collection · Villa Hasna",
      title: "Family",
      titleItalic: "Stay",
      tagline: "A package designed for families who want to enjoy time together in the heart of Marrakech's Palmeraie",
      teaserOverline: "New for 2026",
      teaserTitle: "An all-inclusive family stay at Villa Hasna",
      teaserSubtitle: "The whole house just for you: 3 private suites, 2 nannies, housekeeper, up to 6 guests (2 adults + 4 children).",
      teaserCta: "Discover the 3 packages",
      pitch1: "For the duration of your stay, the three suites of Villa Hasna — a family guesthouse nestled among the palms — are entirely yours.",
      pitch2: "With no overlook, surrounded by 1,700 sqm of garden and a 30 m pool heated in winter, it's a true playground for all ages, just minutes from downtown Marrakech.",
      pitch3: "Our guests enjoy exceptional weather year-round and attentive service, tailored to families who want to reconnect, unwind and share Marrakech with their children in complete peace of mind.",
      houseOverline: "The whole house just for you",
      houseTitle: "Fully privatized villa, up to 6 guests",
      houseDesc: "During your stay, all three suites are privatized for your family (up to 6 guests — 2 adults and 4 children). Our two nannies are part of the house: permanently on site at Villa Hasna, they are people the owners have known and trusted for a long time.",
      bonusOverline: "Included in all three packages",
      bonusTitle: "Comfort, quietly delivered",
      bonusIntro: "On request, free of charge: full baby equipment, indoor and outdoor games, board games (children & adults), music speakers, books.",
      bonus: [
        "Privatization of the 3 suites",
        "Housekeeper on hand",
        "Daily housekeeping included",
        "Unlimited mint tea",
        "Children's suitcase unpacked on arrival, repacked on departure",
        "Pool & garden access",
      ],
      formulasOverline: "Our three packages",
      formulasTitle: "Pick the pace that suits you",
      formulasIntro: "Three packages for a family up to 6 guests, over a full week.",
      perWeek: "/ week",
      forFamily: "for 2 adults + 4 children",
      plusIncluded: "Additionally",
      chooseFormula: "Choose this package",
      terms: "Rates for full privatization of Villa Hasna (3 suites) for 2 adults + 4 children, subject to availability. One-week stays — please contact us for other durations.",
      formulas: {
        essentielle: {
          name: "Essential",
          extras: [
            "Breakfast for the whole family",
            "Round-trip airport shuttle",
            "Nanny available one evening",
          ],
        },
        confort: {
          name: "Comfort",
          plusPrefix: "All of Essential, plus:",
          extras: [
            "Half board",
            "1 round-trip / day by transport",
            "Nanny during the day + one evening",
            "1 massage for the parents",
          ],
        },
        premium: {
          name: "Premium",
          plusPrefix: "All of Comfort, plus:",
          extras: [
            "Private driver on call",
            "Nanny 8h/day + two evenings",
            "1 massage for the parents",
          ],
        },
      },
      ctaOverline: "Want to know more?",
      ctaTitle: "We tailor every family stay",
      ctaSubtitle: "Contact us — our team replies within 24 hours and adapts every package to your needs.",
    },
    services: {
      overline: "Services & Rates",
      title: "A tailor-made experience",
      pool: "Pool",
      dining: "Dining",
      transport: "Transport",
      wellness: "Wellness",
      nanny: "Nanny service",
      housekeeping: "Housekeeping",
      extras: "Extras & Visitors",
      menu: "Din'Art menus",
      menuIntro: "A generous cuisine, between Morocco and the Mediterranean, orchestrated by our private chef.",
    },
    events: {
      overline: "Private events",
      title: "A setting for your most cherished moments",
      subtitle: "Day privatization or with accommodation — on quote.",
      types: [
        "Birthdays",
        "Small religious ceremonies and christenings",
        "Intimate religious weddings",
        "Family gatherings",
        "Residential seminars",
        "Private retreats",
      ],
      contactUs: "Request a quote",
    },
    booking: {
      overline: "Direct booking",
      title: "Request to book",
      subtitle: "Your request is answered within 24 hours. No online payment.",
      villa: "Villa",
      selectVilla: "Select a villa",
      checkIn: "Check-in",
      checkOut: "Check-out",
      guests: "Guests",
      formula: "Formula",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone",
      message: "A message? (occasion, preferences...)",
      submit: "Send request",
      submitting: "Sending...",
      pickDates: "Pick dates",
      success: "Request sent. We'll get back to you within 24h.",
      error: "Something went wrong. Please reach us on WhatsApp.",
      nights: "nights",
      hasnaChoiceLabel: "Preferred suite (Villa Hasna)",
      hasnaChoiceHelp: "Choose a specific suite or full privatization. Can be adjusted with our team.",
      hasnaOptions: {
        entire: "Entire villa — 3 suites, up to 6 guests",
        master: "Master Suite — 25 m Pool & Garden",
        confort: "Confort Suite — king bed, garden view",
        twin: "Twin Palmeraie Suite — 2 single beds",
        undecided: "Not sure yet — let's discuss",
      },
    },
    contact: {
      overline: "Contact",
      title: "Write to us, call us",
      subtitle: "Our team replies in French, English and Arabic.",
      whatsapp: "WhatsApp",
      email: "Email",
      phone: "Phone",
      address: "Address",
      addressValue: "Sidi Yahya La Palmeraie · Marrakech 40 000, Morocco",
      followUs: "Follow us",
    },
    footer: {
      tagline: "Private villa & guesthouse · Palmeraie · Marrakech",
      quickLinks: "Navigation",
      legal: "Legal",
      mentions: "Legal notice",
      privacy: "Privacy",
      copyright: "© 2026 Dar Hasna Collection. All rights reserved.",
    },
    admin: {
      login: "Sign in",
      email: "Email",
      password: "Password",
      signIn: "Sign in",
      signOut: "Sign out",
      dashboard: "Dashboard",
      bookings: "Requests",
      calendars: "iCal calendars",
      stats: "Statistics",
      total: "Total",
      pending: "Pending",
      accepted: "Accepted",
      declined: "Declined",
      accept: "Accept",
      decline: "Decline",
      archive: "Archive",
      guest: "Guest",
      dates: "Dates",
      status: "Status",
      action: "Actions",
      icalAirbnb: "Airbnb iCal URL",
      icalBooking: "Booking.com iCal URL",
      exportUrl: "iCal export URL (add this to Airbnb/Booking)",
      save: "Save",
      saved: "Saved",
      familyLeads: "Family Leads",
      filterAllVillas: "All villas",
      allSuites: "All Hasna suites",
    },
    seniors: {
      title: "Serenity Stays",
      titleItalic: "for Seniors",
      tagline: "Paradise, in full tranquility, in Marrakech.",
      badges: {
        palm: "Palmeraie",
        heated: "Heated pool",
        pension: "Full board & driver",
        massage: "Massages",
        concierge: "Housekeeper on hand",
      },
      pitchOverline: "A cocoon to slow down",
      pitchTitle: "A formula designed for couples who want to take their time.",
      pitch1: "Villa Hasna is a family guesthouse nestled in the heart of the palms, just minutes from downtown Marrakech — full nature, never isolated.",
      pitch2: "With no overlook, surrounded by 1,700 sqm of garden and a pool heated in winter, it is a true haven of peace — designed for seniors who want to rest, explore at their own pace, and feel at home, at their best.",
      homeOverline: "Like home, but better",
      homeTitle: "Each guest enjoys an independent 50 sqm suite — private bathroom, dressing room and terrace.",
      includedOverline: "Included in every formula",
      includedTitle: "Attention at every moment",
      includedIntro: "Whatever the stay, everything is arranged so you can live in complete tranquility — from the first day to the last.",
      included: {
        suite: { title: "Independent 50 sqm suite", desc: "Private bathroom, dressing, terrace, pool and garden access." },
        housekeeping: { title: "Daily housekeeping", desc: "Our team is present throughout the day to take care of you." },
        shuttle: { title: "Round-trip airport shuttle", desc: "Personal welcome on arrival and departure." },
        advice: { title: "Personalized advice", desc: "Activities and visits at your own pace." },
        laundry: { title: "Laundry service", desc: "Laundry included, no extra charge." },
        pool: { title: "Heated pool & garden", desc: "28 m pool, 1,700 sqm garden, no overlook." },
      },
      formulasOverline: "Our three formulas",
      formulasTitle: "Pick the rhythm that suits you",
      formulasIntro: "Three formulas for a couple, from a week to a month, in a dedicated suite.",
      dur: { week: "1 week", fortnight: "15 days", month: "1 month" },
      perCouple: "for 2 persons",
      plusIncluded: "Additionally",
      chooseFormula: "Choose this formula",
      terms: "Rates for a couple, subject to availability on 3 suites dedicated to this offer. Stays from one week to one month.",
      moreOverline: "Want to know more?",
      moreTitle: "We'll send you every formula in detail",
      moreSubtitle: "Contact us — our team replies within 24 hours and tailors each stay.",
    },
    lang: { fr: "FR", en: "EN", ar: "AR" },
    brochure: {
      cta: "Get the brochure",
      modalOverline: "Family Stay · Villa Hasna",
      modalTitle: "Your tailored brochure within 24h",
      modalSubtitle: "Share your preferences — we'll email you the detailed brochure and our team gets back to you within 24 hours.",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone",
      formulaLabel: "Package that interests you",
      formulaAny: "Show me all three packages",
      formulaEssentielle: "Essential · €3,626/week",
      formulaConfort: "Comfort · €5,230/week",
      formulaPremium: "Premium · €5,580/week",
      stayDates: "Preferred dates",
      stayDatesPh: "Ex: July 12-19, 2027",
      guests: "Family composition",
      guestsPh: "Ex: 2 adults + 3 children (5, 8, 12 y.o.)",
      message: "A word for us?",
      submit: "Send and get the brochure",
      submitting: "Sending...",
      success: "Done! Check your inbox in a few minutes.",
      error: "Something went wrong. Please reach us on WhatsApp.",
      privacy: "Your data is used only to send you the brochure and follow up. No third-party sharing.",
    },
  },

  ar: {
    nav: {
      home: "الرئيسية",
      villaIsmael: "فيلا إسماعيل",
      villaHasna: "فيلا حسناء",
      services: "الخدمات والأسعار",
      seniors: "السكينة",
      family: "إقامة عائلية",
      events: "المناسبات الخاصة",
      contact: "اتصل بنا",
      book: "احجز",
    },
    hero: {
      welcome: "مرحبا",
      tagline: "فيلتان استثنائيتان في قلب النخيل",
      subtitle:
        "فيلا حسناء، بيت ضيافة عائلي في قلب نخيل مراكش. 3 أجنحة بحمامات خاصة، مسبح 25 م قابل للتدفئة، حديقة 1700 م² بدون إطلالة الجيران. حجز بالجناح أو خصخصة كاملة (حتى 6 أشخاص).",
      discover: "اكتشف فيلا حسناء",
      checkAvailability: "تحقق من التوفر",
    },
    collection: {
      overline: "البيت",
      title: "بيت ضيافة استثنائي في قلب النخيل",
      description:
        "فيلا حسناء، بيت ضيافة عائلي (3 أجنحة، حتى 6 أشخاص)، يمكن حجزه بالجناح أو بالخصخصة الكاملة. يقع في حديقة 1700 م² بدون إطلالة الجيران، مع مسبح 25 م قابل للتدفئة، على بعد دقائق من وسط مراكش.",
      exploreHasna: "اكتشف فيلا حسناء",
      ismaelTag: "فيلا خاصة · عصري",
      hasnaTag: "بيت ضيافة · بلدي شيك",
    },
    why: {
      overline: "لماذا تختارنا",
      title: "فن الضيافة المغربية",
      privacy: { title: "خصوصية تامة", desc: "فيلتان بدون إطلالة الجيران، في محيط أخضر محفوظ." },
      luxury: { title: "فخامة راقية", desc: "أناقة متزنة، مواد نبيلة، تصميم يستحضر المشاعر." },
      service: { title: "خدمة فندقية", desc: "خادمة، طاهي خاص، تنقلات، عافية: إقامتك منسقة بالكامل." },
      location: { title: "المربع الذهبي للنخيل", desc: "على بعد 3 كم من وسط المدينة، في الحي الأكثر طلبا في مراكش." },
    },
    villa: {
      ismaelCapacity: "حتى 8 أشخاص",
      ismaelSuites: "4 أجنحة مع حمام خاص",
      ismaelPool: "مسبح خاص 28 متر",
      ismaelGarden: "حديقة 1700 م²",
      ismaelMode: "الفيلا بالكامل — خصخصة حصرية",
      hasnaCapacity: "حتى 6 أشخاص",
      hasnaSuites: "3 أجنحة مع حمام خاص",
      hasnaPool: "مسبح خاص 25 متر، قابل للتدفئة شتاءً",
      hasnaGarden: "حديقة 1700 م²",
      hasnaMode: "بيت ضيافة — بالجناح أو بالكامل",
      gallery: "المعرض",
      pricing: "الأسعار",
      book: "اطلب الحجز",
      viewAvailability: "عرض التوفر",
      ismaelStyle: "طراز معاصر، خطوط نقية، أجواء أنيقة وفوتوجينية. خصخصة حصرية.",
      hasnaStyle: "بيت ضيافة عائلي، أجواء بلدي شيك أصيلة، دافئة وخالدة. بالجناح أو بالكامل.",
      ismaelSectionTitle: "4 أجنحة، مسبح 28 م، حديقة استثنائية.",
      hasnaSectionTitle: "3 أجنحة، مسبح 25 م قابل للتدفئة، المضيفون في المكان.",
      hasnaSuiteTwinName: "جناح توين النخيل",
      hasnaSuiteTwinDesc: "سريران مفردان، حمام خاص — وصول مباشر إلى الحديقة والمسبح.",
      hasnaSuiteConfortName: "جناح كومفور",
      hasnaSuiteConfortDesc: "سرير كينغ، حمام خاص، إطلالة على الحديقة.",
      hasnaSuiteMasterName: "الجناح الرئيسي — المسبح والحديقة",
      hasnaSuiteMasterDesc: "جناح استثنائي مع وصول مباشر إلى مسبح 25 م والحديقة الكبيرة للنخيل.",
    },
    pricing: {
      standard: "الصيغة العادية",
      premium: "الصيغة الفاخرة",
      touristTax: "ضريبة الإقامة: 30 درهم / شخص / ليلة",
    },
    priceGrid: {
      overline: "شبكة الأسعار",
      suitesTitle: "احجز جناحًا",
      suitesIntro: "للأزواج أو المسافرين المنفردين — وصول مشترك إلى المسبح والحديقة والمرافق المشتركة.",
      entireTitle: "خصخصة الفيلا بالكامل",
      entireIntro: "الفيلا بأكملها لك حصريا.",
      pricePerNight: "/ ليلة",
      lowSeason: "موسم منخفض",
      highSeason: "موسم مرتفع",
      fromLabel: "ابتداء من",
      touristTax: "ضريبة الإقامة: 30 درهم / شخص / ليلة",
      minStay: "الحد الأدنى للإقامة: ليلتان",
      hasnaEntireLabel: "فيلا حسناء بالكامل — 3 أجنحة، حتى 6 أشخاص",
      ismaelEntireLabel: "فيلا إسماعيل بالكامل — 4 أجنحة، حتى 8 أشخاص",
      bookThisSuite: "احجز هذا الجناح",
      bookEntire: "خصخصة الفيلا",
    },
    family: {
      pageTitle: "إقامة عائلية — فيلا حسناء",
      overline: "دار حسناء كولكشن · فيلا حسناء",
      title: "إقامة",
      titleItalic: "عائلية",
      tagline: "صيغة مصممة للعائلات التي تريد الاستمتاع معًا في قلب نخيل مراكش",
      teaserOverline: "جديد 2026",
      teaserTitle: "إقامة عائلية شاملة في فيلا حسناء",
      teaserSubtitle: "المنزل بأكمله لك: 3 أجنحة خاصة، مربيتان، مدبرة منزل، حتى 6 أشخاص (بالغان + 4 أطفال).",
      teaserCta: "اكتشف الصيغ الثلاث",
      pitch1: "طوال إقامتكم، الأجنحة الثلاثة لفيلا حسناء، بيت الضيافة العائلي الواقع في قلب النخيل، محجوزة لكم بالكامل.",
      pitch2: "دون أي إطلالة على الجيران، محاطة بحديقة 1700 م² ومسبح 30 م مدفأ في الشتاء، إنه ملعب حقيقي للصغار والكبار، على بعد دقائق فقط من وسط مراكش.",
      pitch3: "يستمتع ضيوفنا بمناخ استثنائي طوال العام وخدمة مخصصة، مصممة للعائلات التي تريد إعادة التواصل، الراحة واكتشاف مراكش مع أطفالها بكل هدوء.",
      houseOverline: "المنزل بأكمله لك",
      houseTitle: "فيلا مخصصة بالكامل، حتى 6 أشخاص",
      houseDesc: "خلال إقامتكم، الأجنحة الثلاثة خاصة بعائلتكم (حتى 6 أشخاص — بالغان و 4 أطفال). مربيتانا جزء من المنزل: حاضرتان دائمًا في فيلا حسناء، شخصان يعرفهما المالكون ويثقان بهما منذ فترة طويلة.",
      bonusOverline: "مشمول في الصيغ الثلاث",
      bonusTitle: "الراحة، بكل هدوء",
      bonusIntro: "عند الطلب، مجانًا: تجهيزات الرضع الكاملة، ألعاب داخلية وخارجية، ألعاب طاولة (أطفال وبالغون)، مكبرات صوت، كتب.",
      bonus: [
        "خصخصة الأجنحة الثلاثة",
        "مدبرة منزل تحت الطلب",
        "تنظيف يومي مشمول",
        "شاي بالنعناع بلا حدود",
        "حقيبة الأطفال يتم ترتيبها عند الوصول وإعادة تعبئتها عند المغادرة",
        "وصول إلى المسبح والحديقة",
      ],
      formulasOverline: "صيغنا الثلاث",
      formulasTitle: "اختر الإيقاع الذي يناسبك",
      formulasIntro: "ثلاث صيغ لعائلة حتى 6 أشخاص، لأسبوع كامل.",
      perWeek: "/ أسبوع",
      forFamily: "لبالغين + 4 أطفال",
      plusIncluded: "بالإضافة إلى",
      chooseFormula: "اختر هذه الصيغة",
      terms: "الأسعار للخصخصة الكاملة لفيلا حسناء (3 أجنحة) لبالغين + 4 أطفال، حسب التوفر. إقامة لمدة أسبوع — يرجى الاتصال بنا لمدد أخرى.",
      formulas: {
        essentielle: {
          name: "أساسية",
          extras: [
            "فطور للعائلة بأكملها",
            "نقل من وإلى المطار",
            "مربية متاحة أمسية واحدة",
          ],
        },
        confort: {
          name: "مريحة",
          plusPrefix: "كل الأساسية، بالإضافة إلى:",
          extras: [
            "نصف إقامة",
            "رحلة ذهاب وإياب / يوم بالنقل",
            "مربية خلال النهار + أمسية",
            "جلسة تدليك مهداة للوالدين",
          ],
        },
        premium: {
          name: "ممتازة",
          plusPrefix: "كل المريحة، بالإضافة إلى:",
          extras: [
            "سائق خاص تحت الطلب",
            "مربية 8 ساعات/يوم + أمسيتان",
            "جلسة تدليك مهداة للوالدين",
          ],
        },
      },
      ctaOverline: "هل تريد معرفة المزيد؟",
      ctaTitle: "نخصص كل إقامة عائلية",
      ctaSubtitle: "اتصل بنا — يرد فريقنا خلال 24 ساعة ويكيف كل صيغة حسب رغباتك.",
    },
    services: {
      overline: "الخدمات والأسعار",
      title: "تجربة على المقاس",
      pool: "المسبح",
      dining: "المطعم",
      transport: "النقل",
      wellness: "العافية",
      nanny: "مربية أطفال",
      housekeeping: "خادمة",
      extras: "أشخاص وزوار",
      menu: "قوائم دين آرت",
      menuIntro: "مطبخ سخي، بين المغرب والبحر الأبيض المتوسط، من إعداد طاهينا الخاص.",
    },
    events: {
      overline: "المناسبات الخاصة",
      title: "إطار لأجمل لحظاتكم",
      subtitle: "خصخصة يومية أو مع الإقامة — بحسب العرض.",
      types: [
        "أعياد الميلاد",
        "حفلات المعمودية والحفلات الدينية الصغيرة",
        "حفلات الزفاف الدينية الحميمة",
        "لم شمل العائلة",
        "الندوات السكنية",
        "الخلوات الخاصة",
      ],
      contactUs: "اطلب عرض سعر",
    },
    booking: {
      overline: "حجز مباشر",
      title: "اطلب الحجز",
      subtitle: "يتم الرد على طلبك خلال 24 ساعة. لا يوجد دفع عبر الإنترنت.",
      villa: "الفيلا",
      selectVilla: "اختر فيلا",
      checkIn: "الوصول",
      checkOut: "المغادرة",
      guests: "الضيوف",
      formula: "الصيغة",
      firstName: "الاسم الأول",
      lastName: "اللقب",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      message: "رسالة؟ (المناسبة، التفضيلات...)",
      submit: "إرسال الطلب",
      submitting: "جار الإرسال...",
      pickDates: "اختر التواريخ",
      success: "تم إرسال الطلب. سنعود إليك خلال 24 ساعة.",
      error: "حدث خطأ. اتصل بنا عبر واتساب.",
      nights: "ليال",
      hasnaChoiceLabel: "الجناح المرغوب (فيلا حسناء)",
      hasnaChoiceHelp: "اختر جناحًا معينًا أو الخصخصة الكاملة. قابل للتعديل مع فريقنا.",
      hasnaOptions: {
        entire: "الفيلا بالكامل — 3 أجنحة، حتى 6 أشخاص",
        master: "الجناح الرئيسي — مسبح 25 م وحديقة",
        confort: "جناح كومفور — سرير كينغ، إطلالة على الحديقة",
        twin: "جناح توين النخيل — سريران مفردان",
        undecided: "لم أقرر بعد — للنقاش",
      },
    },
    contact: {
      overline: "اتصل بنا",
      title: "اكتب لنا، اتصل بنا",
      subtitle: "يرد فريقنا بالفرنسية والإنجليزية والعربية.",
      whatsapp: "واتساب",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      address: "العنوان",
      addressValue: "النخيل، مراكش، المغرب",
      followUs: "تابعنا",
    },
    footer: {
      tagline: "فيلا خاصة وبيت ضيافة · النخيل · مراكش",
      quickLinks: "التنقل",
      legal: "قانوني",
      mentions: "إشعارات قانونية",
      privacy: "الخصوصية",
      copyright: "© 2026 دار حسناء كولكشن. جميع الحقوق محفوظة.",
    },
    admin: {
      login: "تسجيل الدخول",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      signIn: "تسجيل الدخول",
      signOut: "تسجيل الخروج",
      dashboard: "لوحة القيادة",
      bookings: "الطلبات",
      calendars: "تقويمات iCal",
      stats: "إحصاءات",
      total: "المجموع",
      pending: "قيد الانتظار",
      accepted: "مقبولة",
      declined: "مرفوضة",
      accept: "قبول",
      decline: "رفض",
      archive: "أرشفة",
      guest: "الضيف",
      dates: "التواريخ",
      status: "الحالة",
      action: "إجراءات",
      icalAirbnb: "رابط iCal Airbnb",
      icalBooking: "رابط iCal Booking.com",
      exportUrl: "رابط تصدير iCal (أضفه إلى Airbnb/Booking)",
      save: "حفظ",
      saved: "تم الحفظ",
      familyLeads: "طلبات الإقامة العائلية",
      filterAllVillas: "كل الفيلات",
      allSuites: "كل أجنحة حسناء",
    },
    seniors: {
      title: "إقامات السكينة",
      titleItalic: "لكبار السن",
      tagline: "الجنة، في كل هدوء، في مراكش.",
      badges: {
        palm: "النخيل",
        heated: "مسبح مدفأ",
        pension: "إقامة كاملة وسائق",
        massage: "تدليك",
        concierge: "مربية المنزل تحت الطلب",
      },
      pitchOverline: "ملاذ لأخذ الوقت الكافي",
      pitchTitle: "صيغة مصممة للأزواج الذين يرغبون في أخذ وقتهم.",
      pitch1: "فيلا حسناء بيت ضيافة عائلي يقع في قلب النخيل، على بعد دقائق فقط من وسط مدينة مراكش — الطبيعة الكاملة، دون أن تكون منعزلاً أبدًا.",
      pitch2: "دون أي إطلالة على الجيران، محاطة بحديقة بمساحة 1700 م² ومسبح مدفأ في الشتاء، إنها ملاذ حقيقي للسلام — مصممة لكبار السن الذين يرغبون في الراحة والزيارة على وتيرتهم والشعور بأنهم في منازلهم، في أفضل حالاتهم.",
      homeOverline: "كما في المنزل، بل أفضل",
      homeTitle: "يتمتع كل ضيف بجناح مستقل بمساحة 50 م² — حمام خاص، غرفة ملابس وشرفة.",
      includedOverline: "مشمول في كل صيغة",
      includedTitle: "اهتمام في كل لحظة",
      includedIntro: "مهما كانت الإقامة، كل شيء مرتب لتعيش في هدوء تام — من اليوم الأول إلى الأخير.",
      included: {
        suite: { title: "جناح مستقل 50 م²", desc: "حمام خاص، غرفة ملابس، شرفة، وصول إلى المسبح والحديقة." },
        housekeeping: { title: "تنظيف يومي", desc: "فريقنا حاضر طوال اليوم للاعتناء بك." },
        shuttle: { title: "نقل من وإلى المطار", desc: "استقبال شخصي عند الوصول والمغادرة." },
        advice: { title: "نصائح شخصية", desc: "أنشطة وزيارات على وتيرتك الخاصة." },
        laundry: { title: "خدمة الغسيل", desc: "الغسيل مشمول، دون رسوم إضافية." },
        pool: { title: "مسبح مدفأ وحديقة", desc: "مسبح 28 م، حديقة 1700 م²، دون إطلالة على الجيران." },
      },
      formulasOverline: "صيغنا الثلاث",
      formulasTitle: "اختر الإيقاع الذي يناسبك",
      formulasIntro: "ثلاث صيغ لزوجين، من أسبوع إلى شهر، في جناح مخصص.",
      dur: { week: "أسبوع واحد", fortnight: "15 يومًا", month: "شهر واحد" },
      perCouple: "لشخصين",
      plusIncluded: "بالإضافة إلى",
      chooseFormula: "اختر هذه الصيغة",
      terms: "الأسعار لزوجين، سارية حسب التوفر على أساس 3 أجنحة مخصصة لهذا العرض. إقامات ممكنة من أسبوع إلى شهر.",
      moreOverline: "هل تريد معرفة المزيد؟",
      moreTitle: "سنرسل لك كل صيغة بالتفصيل",
      moreSubtitle: "اتصل بنا — يرد فريقنا خلال 24 ساعة ويخصص كل إقامة.",
    },
    lang: { fr: "FR", en: "EN", ar: "AR" },
    brochure: {
      cta: "احصل على الكتيب",
      modalOverline: "الإقامة العائلية · فيلا حسناء",
      modalTitle: "كتيبك المخصص خلال 24 ساعة",
      modalSubtitle: "شارك تفضيلاتك — سنرسل لك الكتيب المفصل عبر البريد الإلكتروني ويعود إليك فريقنا خلال 24 ساعة.",
      firstName: "الاسم الأول",
      lastName: "اللقب",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      formulaLabel: "الصيغة التي تهمك",
      formulaAny: "أعرض لي الصيغ الثلاث",
      formulaEssentielle: "أساسية · 3626 يورو/أسبوع",
      formulaConfort: "مريحة · 5230 يورو/أسبوع",
      formulaPremium: "ممتازة · 5580 يورو/أسبوع",
      stayDates: "التواريخ المفضلة",
      stayDatesPh: "مثال: 12-19 يوليو 2027",
      guests: "تكوين العائلة",
      guestsPh: "مثال: بالغان + 3 أطفال (5، 8، 12 سنة)",
      message: "كلمة لنا؟",
      submit: "إرسال والحصول على الكتيب",
      submitting: "جار الإرسال...",
      success: "تم! تحقق من صندوق البريد الوارد بعد دقائق قليلة.",
      error: "حدث خطأ. اتصل بنا عبر واتساب.",
      privacy: "بياناتك تُستخدم فقط لإرسال الكتيب والمتابعة. لا مشاركة مع أطراف ثالثة.",
    },
  },
};
